

import React, { useContext } from 'react'
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../context/InsuracePurchaseContext';
import { ACTIONS, PolicyManagementContextStore } from '../../context/PolicyManagementContext';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { Action } from '../../models/Action';
import policymanagementApi from '../../api/policymanagement.api';
import { awaitWithLoading } from '../../services/utils';
import { AdditionalInsuredPureForm } from './AdditionalInsuredPureForm';
import { UserApi } from '../../api/user.api';
import { ModificationApi } from '../../api/modification.api';
import { useParams } from 'react-router-dom';

export const AdditionalInsuredForm = ({closeDialog, insurance}) => {
    const isPolicyManagementMode = !!insurance
    const insuranceId  = insurance?.insuranceId
    const context = useContext(isPolicyManagementMode ? PolicyManagementContextStore : InsurancePurchaseContextStore)
    const getAdditionalInsuredList = () => isPolicyManagementMode ?  context.activeAdditionalInsuredList : context.additionalInsuredList
    const getAllAdditionalInsuredList = () => context.allAdditionalInsuredList;

    const onListUpdate = async (activeAiList, allAiList) => {
        if (isPolicyManagementMode){
            const body = {
                "additional_insureds": allAiList.map(q => {return {...q, email: q.email? q.email : undefined, newId: undefined}})
                }
            const res = await awaitWithLoading(ModificationApi.modifyAdditionalInsured(insurance.insuranceId, body))
            if(res.ok) {
                EventEmitterService.dispatch(EventKey.POLICY_ADDITIONAL_INSURED_CHANGED);
                const resAllAi = await awaitWithLoading(UserApi.getAdditionalInsureds(insuranceId))
                if (resAllAi.ok){
                    context.dispatch(new Action(ACTIONS.TOTAL_ADDITIONAL_INSUREDS_UPDATED,{additional_insureds: resAllAi.parsedData}))
                    context.dispatch(new Action(ACTIONS.ACTIVE_ADDITIONAL_INSUREDS_UPDATED,{additional_insureds: resAllAi.parsedData.filter(i => i.is_covered === true)}))
                }
                closeDialog()
            }
            else {
                EventEmitterService.dispatch(EventKey.ShowError, res)
            }
        }
        else{
            context.dispatch(new Action(INSURANCE_CONTEXT_ACTIONS.TOTAL_ADDITIONAL_INSUREDS_UPDATED, {additional_insureds: allAiList}));
            context.dispatch(new Action(INSURANCE_CONTEXT_ACTIONS.ACTIVE_ADDITIONAL_INSUREDS_UPDATED, {additional_insureds: activeAiList}));
        }
    }

    const onFinish = () => EventEmitterService.dispatch(EventKey.ADDITIONAL_INSURED_FINISH)

    return (
        <AdditionalInsuredPureForm
            onAdditionalInsuredListUpdate={onListUpdate}
            onFinish={onFinish}
            additionalInsuredList={getAdditionalInsuredList()} 
            allAdditionalInsuredList={getAllAdditionalInsuredList()}
            />
    )
}